module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-panel', {
    attrs: {
      "contextual-style": "primary"
    }
  }, [_c('h1', {
    staticClass: "panel-title",
    slot: "heading"
  }, [_vm._v("\n      Password Reset\n    ")]), _vm._v(" "), (!_vm.emailSent) ? _c('div', {
    slot: "body"
  }, [_c('p', [_vm._v("\n        Please confirm your email address below:"), _c('br')]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.resetpw()
      }
    }
  }, [_c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": "",
      "type": "button",
      "aria-label": "Help"
    }
  }, [_c('i', {
    staticClass: "fa fa-key fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "autofocus": "",
      "placeholder": "New password",
      "aria-label": "New password"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticClass: "input-group-btn",
    attrs: {
      "align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": _vm.doingSomething,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.resetpw()
      }
    }
  }, [_vm._v("Reset Password")])])])]), _vm._v(" "), (_vm.errmsg !== '') ? _c('p', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('br'), _vm._v("ERROR: " + _vm._s(_vm.errmsg) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.emailSent) ? _c('div', {
    slot: "body"
  }, [_c('p', [_vm._v("\n        A password reset link has been sent to your registered email address (" + _vm._s(_vm.email) + ")."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        Please click the link in the email to reset your password.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n         \n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    slot: "footer"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d44ca456"}!./src/app/pages/user/resetpwblind/index.html
// module id = 235
// module chunks = 1